import React, { useEffect, useState } from "react";
import swal from "sweetalert2";
import Loader from "../components/Loader";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { Divider, Space, Tag } from "antd";

function Mybookngs() {
	const [loading, setloading] = useState(false);
	const [error, seterror] = useState();
	const user = JSON.parse(localStorage.getItem("currentuser"));
	const [bookings, setbookings] = useState([]);
	useEffect(() => {
			AOS.init({ duration: 500 });
		try {
			setloading(true);
			axios
				.post("https://online-hotels-booking-system-server.vercel.app/api/bookings/getbookingsbyuserid", {
					userid: user._id,
				})
				.then((response) => {
					console.log(response.data);
					setbookings(response.data);
					setloading(false);
				});
		} catch (error) {
			seterror(true);
			setloading(false);
			console.log(error);
		}
	}, []);


    async function cancelbooking(bookingid, roomid) {
			try {
				setloading(true);
				await axios
					.post("https://online-hotels-booking-system-server.vercel.app/api/bookings/cancelbooking", {
						bookingid,
						roomid,
					})
					.then((response) => {
						setloading(false);
						swal
							.fire(
								"Congratulation",
								"Your Room Booking has been Cancelled",
								"success"
							)
							.then((result) => {
								window.location.reload();
							});
					});
			} catch (error) {
				seterror(true);
				setloading(false);
				swal.fire("Oops", "Simething went wrong", "error");
			}
		}
	return (
		<div>
			<div data-aos="flip-down" className="row">
				<div className="col-md-6">
					{loading && <Loader />}
					{bookings &&
						bookings.map((booking) => {
							return (
								<div className="bs">
									<h1>{booking.room}</h1>
									<p>
										<b>Booking ID:</b> {booking._id}
									</p>
									<p>
										<b>CheckIn: </b>
										{booking.fromdate}
									</p>
									<p>
										<b>CheckOut: </b>
										{booking.todate}
									</p>
									<p>
										<b>Amount:</b> {booking.totalamount}
									</p>
									<p>
										<b>Status: </b>

										{booking.status == "cancelled" ? (
											<Tag color="red">CANCELLED</Tag>
										) : (
											<Tag color="green">CONFIRM</Tag>
										)}
									</p>

									{booking.status !== "cancelled" && (
										<div style={{ textAlign: "right" }}>
											<button
												className="btn btn-primary"
												onClick={() => {
													cancelbooking(booking._id, booking.roomid);
												}}>
												CANCEL BOOKING
											</button>
										</div>
									)}
								</div>
							);
						})}
				</div>
			</div>
		</div>
	);
}

export default Mybookngs;
